<template>
  <router-link :to="detailLink" class="special-orders-details-card">
    <strapi-image
      :image="instance.cover"
      :width="270"
      :height="270"
      class="special-orders-details-card-image"
      sizes="xs:170px md:215px lg:270px"
      :preload="mediaPreload"
    />
    <h2 class="special-orders-details-card-name">
      {{ instance.title }}
    </h2>
  </router-link>
</template>

<script setup lang="ts">
import { SpecialOrdersDetailsCard as ISpecialOrdersDetailsCard } from "../interfaces";
import { StrapiImage } from "~/components/strapi";
import { MediaFetchPriority } from "~/modules/media/types/MediaFetchPriority";

const props = defineProps<{
  instance: ISpecialOrdersDetailsCard;
  mediaPreload?: MediaFetchPriority;
}>();

const { specialOrderSingleLink } = useSpecialOrderLinker();
const detailLink = computed(() => specialOrderSingleLink(props.instance));
</script>

<style lang="scss">
.special-orders-details-card {
  @apply flex flex-col items-center justify-start border border-solid border-transparent p-2 hover:border-secondary-600 focus:border-secondary-600;

  &-image {
    @apply h-full max-h-[269px] w-full max-w-[269px] object-contain;
  }

  &-name {
    @apply p-5 text-center text-base font-semibold md:text-2xl;
  }
}
</style>
